import CryptoJS from 'crypto-js'

const secretKey = process.env.REACT_APP_KEY
const iv = process.env.REACT_APP_IV



var helper = {
    convertData: async (data) => {
        try {
            if (data) {
                const Key = CryptoJS.enc.Base64.parse(secretKey);
                const Iv = CryptoJS.enc.Base64.parse(iv);
                let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), Key, { iv: Iv }).toString();

                if (encrypted) {
                    return encrypted;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },
    revertData: async (data) => {
        try {
            if (data) {

                const Key = CryptoJS.enc.Base64.parse(secretKey);
                const Iv = CryptoJS.enc.Base64.parse(iv);
                let decrypted = CryptoJS.AES.decrypt(data.toString(), Key, { iv: Iv });
                if (decrypted) {
                    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    },
    RemoveSpecialCharacter: (event) => {
        const pastedText = event.clipboardData.getData('text');
        if (/[^\w\s.@/_]/.test(pastedText)) {
            event.preventDefault();
        }
    },
    formatDate: (date, type = 1) => {

        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var dates = date.getDate();
        var months = date.getMonth() + 1;
        var years = date.getFullYear();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        dates = dates < 10 ? "0" + dates : dates;
        months = months < 10 ? "0" + months : months;
        var strTime = hours + ":" + minutes + ":" + seconds + " " + ampm;
        if (type == 1) {

            return <div className="d-flex flex-column">
                <span>{dates + "-" + months + "-" + years}</span>
                <span>{strTime}</span>
            </div>;
        }
        if (type == 0) {
            return dates + "-" + months + "-" + years + " " + strTime;
        }
    },
    saveToStorage: async (key, data) => {
        try {
            const encrypted = await helper.convertData(data);
            if (encrypted) {
                localStorage.setItem(key, encrypted);
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    },

    getFromStorage: async (key) => {
        try {
            const encrypted = localStorage.getItem(key);
            if (!encrypted) return null;
            const decrypted = await helper.revertData(encrypted);
            return decrypted;

        } catch (error) {
            return null;
        }
    }

}
export default helper